"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = _styledComponents.default.main.withConfig({
  displayName: "Main",
  componentId: "i3wdvw-0"
})(["display:flex;flex-direction:column;flex-wrap:wrap;width:100%;max-width:1040px;margin:0 auto;padding:0 16px;"]);

var _default = Main;
exports.default = _default;